import React from "react";
import COLORS from "../../constants/colors";
import FlowTopBar from "../common/FlowTopBar";
import {
  mainCardStyle,
  pageStyle,
  smallTopBtnStyle,
  primaryBtnStyle,
} from "../../styles/commonStyles";
import { speakFrench } from "../../utils/speech";

export default function SpellingPracticePage({
  word,
  progressText,
  inputValue,
  checkState = "idle",
  wrongHint = "",
  showSpellingHint = false,
  onShowHint,
  onChangeInput,
  onCheck,
  onPrev,
  onStar,
  onSkip,
  onHome,
  disablePrev = false,
}) {
  if (!word) return null;

  const isCorrect = checkState === "correct";
  const isWrong = checkState === "wrong";

  return (
    <div style={pageStyle()}>
      <div style={mainCardStyle()}>
        <FlowTopBar
          title={`拼写复习进度：${progressText}`}
          onPrev={onPrev}
          onStar={onStar}
          onSkip={onSkip}
          onHome={onHome}
          disablePrev={disablePrev}
        />

        <div
          style={{
            marginTop: "2.2rem",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <input
            value={inputValue}
            onChange={(e) => onChangeInput(e.target.value)}
            placeholder="请拼写法语单词"
            style={{
              width: "100%",
              maxWidth: "420px",
              border: "none",
              outline: "none",
              borderBottom: `3px solid ${
                isCorrect ? COLORS.green : isWrong ? COLORS.red : "#C9CDD4"
              }`,
              padding: "0.8rem 0.4rem",
              fontSize: "1.5rem",
              textAlign: "center",
              background: "transparent",
              caretColor: COLORS.green,
              color: COLORS.text,
            }}
          />
        </div>

        <div
          style={{
            textAlign: "center",
            marginTop: "1.4rem",
            color: COLORS.text,
            fontWeight: 700,
            fontSize: "1.08rem",
          }}
        >
          {word.type} · {word.translation}
        </div>

        <div
          style={{
            textAlign: "center",
            marginTop: "0.7rem",
            display: "flex",
            justifyContent: "center",
            gap: "0.8rem",
            alignItems: "center",
          }}
        >
          <button
            onClick={() => speakFrench(word.word)}
            style={{
              ...smallTopBtnStyle("#EEF4FB"),
              width: "48px",
              height: "48px",
              fontSize: "1.2rem",
            }}
          >
            🔊
          </button>

          <button
            onClick={onShowHint}
            style={{
              ...primaryBtnStyle(),
              padding: "0.65rem 1rem",
            }}
          >
            提示
          </button>
        </div>

        {showSpellingHint && (
          <div
            style={{
              textAlign: "center",
              marginTop: "1rem",
              color: COLORS.blue,
              fontWeight: 700,
              fontSize: "1.15rem",
            }}
          >
            {word.word}
          </div>
        )}

        {isWrong && (
          <div
            style={{
              textAlign: "center",
              marginTop: "1rem",
              color: COLORS.red,
              lineHeight: 1.7,
            }}
          >
            {wrongHint || "拼写有误，请检查后继续。"}
          </div>
        )}

        {isCorrect && (
          <div
            style={{
              textAlign: "center",
              marginTop: "1rem",
              color: COLORS.green,
              fontWeight: 700,
            }}
          >
            拼写正确，即将进入下一个单词
          </div>
        )}

        <div style={{ display: "flex", justifyContent: "center", marginTop: "2rem" }}>
          <button
            onClick={onCheck}
            style={{
              width: "64px",
              height: "64px",
              borderRadius: "50%",
              border: `1px solid ${isCorrect ? COLORS.green : "#DADFE6"}`,
              background: isCorrect ? COLORS.green : "#fff",
              color: isCorrect ? "#fff" : COLORS.text,
              fontSize: "1.5rem",
              fontWeight: 900,
              cursor: "pointer",
              boxShadow: "0 10px 20px rgba(0,0,0,0.05)",
            }}
          >
            ✔
          </button>
        </div>
      </div>
    </div>
  );
}